import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FileIcon = props => {
  return <FontAwesomeIcon icon="fa-solid fa-file-lines" {...props} />;
};

export default FileIcon;
